/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type CalendarAssignedStaffInput = {
  guid: string | number;
  priority?: number | null | undefined;
};

export type CalendarDailyAvailabilityInput = {
  dayOfWeek: DayOfWeek;
  from: CalendarTimeOfDayInput;
  until: CalendarTimeOfDayInput;
};

export type CalendarQuestionInput = {
  options?: Array<string> | null | undefined;
  order: number;
  questionText: string;
  status: CalendarQuestionStatus;
  type: CalendarQuestionType;
};

export type CalendarQuestionStatus =
  | 'OPTIONAL'
  | 'REQUIRED';

export type CalendarQuestionType =
  | 'SELECT_BOX'
  | 'TEXT';

export type CalendarSettingInput = {
  assignedStaffs: Array<CalendarAssignedStaffInput>;
  dailyAvailabilities: Array<CalendarDailyAvailabilityInput>;
  description?: string | null | undefined;
  privateTitle?: string | null | undefined;
  publicTitle: string;
  questions: Array<CalendarQuestionInput>;
  slackChannelID?: string | null | undefined;
  slotDurationMinutes: number;
  slotGenerationDelayHours: number;
  slotGenerationPeriodDays: number;
  slotOffsetMinutes: number;
  staffSelectionStrategy: CalendarStaffSelectionStrategy;
  status: CalendarStatus;
};

export type CalendarStaffSelectionStrategy =
  | 'PRIORITY'
  | 'RANDOM';

export type CalendarStatus =
  | 'ACTIVE'
  | 'INACTIVE';

export type CalendarTimeOfDayInput = {
  hours: number;
  minutes: number;
};

export type CreateCalendarInput = {
  setting: CalendarSettingInput;
};

export type DayOfWeek =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

export type CreateCalendarMutationVariables = Exact<{
  input: Types.CreateCalendarInput;
}>;


export type CreateCalendarMutation = { createCalendar: { guid: string } };


export const CreateCalendarDocument = gql`
    mutation CreateCalendar($input: CreateCalendarInput!) {
  createCalendar(input: $input) {
    guid
  }
}
    `;

/**
 * __useCreateCalendarMutation__
 *
 * To run a mutation, you first call `useCreateCalendarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalendarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCalendarMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCalendarMutation(options: VueApolloComposable.UseMutationOptions<CreateCalendarMutation, CreateCalendarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCalendarMutation, CreateCalendarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCalendarMutation, CreateCalendarMutationVariables>(CreateCalendarDocument, options);
}
export type CreateCalendarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCalendarMutation, CreateCalendarMutationVariables>;